import { render, staticRenderFns } from "./upgrade_pc.vue?vue&type=template&id=34044a82&scoped=true&"
import script from "./upgrade_pc.vue?vue&type=script&lang=js&"
export * from "./upgrade_pc.vue?vue&type=script&lang=js&"
import style0 from "./upgrade_pc.vue?vue&type=style&index=0&id=34044a82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34044a82",
  null
  
)

export default component.exports